export class StoredQuestion {
    id:string;
    selectedAnswerIndex : string;
    done: boolean;
    isSkiped : boolean;
    isNew : boolean
    answerId: string;
    questionNumber: string;
    isGroup : boolean;
    questionLable:string;
    questionType: string;
    isMain: boolean;
    parentObjId: any;
    q : any;
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/storedQuestion.ts